export enum DevelopmentTranslation {
  EnquireAboutFunding = "Domains.Development.EnquireAboutFunding",
  EnquireAboutFundingTooltip = "Domains.Development.EnquireAboutFundingTooltip",
  FundingEnquirySent = "Domains.Development.FundingEnquirySent",
  FundingEnquirySentTooltip = "Domains.Development.FundingEnquirySentTooltip"
}
